import { Skeleton } from "@mui/material";
import React from "react";

interface TabsSkeletonProps {}

const TabsSkeleton = (props: TabsSkeletonProps) => {
  return (
    <div className="dui-tabs-skeleton-wrapper">
      <Skeleton
        variant="rounded"
        height={48}
        width={300}
        className="dui-tabs-skeleton"
      />
    </div>
  );
};

export default TabsSkeleton;
